import { useMemo } from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { useActionChoices } from "stores";
import { ACTION_STATUS } from "constants/actions";
import { Button } from "components";
import { TASKS } from "constants/actions";

const NewActionModalHeader = ({ onSubmit, isLoading, isToggleHidden }) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext();
  const { isSpecificAction } = useActionChoices();

  const handleStatusChange = (e) => {
    setFieldValue(
      "status",
      e.target.checked ? ACTION_STATUS.performed : ACTION_STATUS.suggested,
    );
  };

  const isToggleDisabled = useMemo(() => {
    return isSpecificAction(TASKS.observation, values.taskId);
  }, [isSpecificAction, values.taskId]);

  return (
    <div className="header-row space-between">
      <div className="header-title">{t("ActionModal.Mode.NewAction")}</div>
      <div className="header-btn-group">
        {!isToggleHidden && (
          <FormControlLabel
            control={<Switch onChange={handleStatusChange} />}
            checked={values.status === ACTION_STATUS.performed}
            disabled={isToggleDisabled}
            label={t("ActionModal.PerformedAction")}
          />
        )}
        <Button
          variant="filled"
          corners="square"
          isLoading={isLoading}
          isDisabled={isLoading}
          className="action-button"
          onClick={onSubmit}
        >
          {t("ActionModal.SubmitButton")}
        </Button>
      </div>
    </div>
  );
};
export default NewActionModalHeader;
